<script setup lang="ts">
/**
 * UI-kit component
 * Category: Switchers
 * Name: AppSwitcherItem
 * FIGMA: https://www.figma.com/design/oRsJUOAucnhxx5aeqy4TRO/APP-admin?node-id=3458-4019&m=dev
 */
import type { AppSwitcherItemProps } from '../types/interfaces'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { IconContainer } from '@shared/ui/other'

import { useAppSwitcherItem } from '../composables/use-app-switcher-item.hook'

defineOptions({
  name: 'AppSwitcherItem',
})

const props = withDefaults(defineProps<AppSwitcherItemProps>(), {
  selected: false,
  disabled: false,
  prependIcon: undefined,
})

const emit = defineEmits<{
  click: []
}>()

const {
  handleClick,
} = useAppSwitcherItem({
  props,
  onClick: () => emit('click'),
})
</script>

<template>
  <button
    type="button"
    :class="['ui-app-switcher-item', { selected, disabled }]"
    :disabled="disabled"
    @click="handleClick"
  >
    <IconContainer
      v-if="prependIcon"
      class="ui-app-switcher-item__icon"
    >
      <FontAwesomeIcon :icon="prependIcon" />
    </IconContainer>
    <span class="ui-app-switcher-item__text">
      {{ text }}
    </span>
  </button>
</template>

<style lang="scss" scoped src="../styles/_app-switcher-item.scss" />
